module.exports = "<div class=\"container-row\">\r\n  <div class=\"row row-100\">\r\n    <form [formGroup]=\"objForm\" novalidate>\r\n      <app-dual-list-box formControlName=\"objectData\"></app-dual-list-box>\r\n    </form>\r\n  </div>\r\n</div>\r\n\r\n<app-t2-loading></app-t2-loading>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/exclude-providers/components/exclude-providers/exclude-providers.component.html
// module id = 2613
// module chunks = 66